import { BRAND_KIT_ACCEPT_FORMATS } from '../../constants';
import useBrandKitComponent from '../useBrandKitComponent';
import IntroOutroPreview from './IntroOutroPreview';
import FilesInput from '@/components/atoms/inputs/FilesInput/FilesInput';
import { showErrorToast } from '@/libs/toast/toast';
import { VIDEO_SEGMENT_MAX_FILE_SIZE } from '@/Pages/Clip/ClipPlayer/ClipNewTimeline/constants';
import styles from '../../BrandKit.module.scss';

export default function IntroOutro(): JSX.Element {
  const { brandKitStore, onFilesUpload, deleteItem } = useBrandKitComponent({
    key: 'intro_outro',
    title: 'Intro/Outro Videos',
    maxFileSize: VIDEO_SEGMENT_MAX_FILE_SIZE
  });

  function uploadFiles(files: File[]) {
    onFilesUpload(files).catch(() =>
      showErrorToast(
        'Whoops! Looks like uploading your Intro/Outro hit a snag. Ensure the file format is correct and retry.'
      )
    );
  }

  return (
    <div className="relative flex flex-wrap gap-3 py-2">
      <div className="flex aspect-[16/11] w-56 flex-col items-center justify-center !text-slate-500">
        <FilesInput
          onFilesUpload={uploadFiles}
          accept={BRAND_KIT_ACCEPT_FORMATS.introOutro}
          label="Add Intro/Outro Video"
          icon="IconMovie"
          containerClassNames={styles['brand-picker']}
          labelClassNames="text-xs"
          iconProps={{
            size: 20,
            stroke: 1.5
          }}
        />
      </div>
      {brandKitStore.intro_outro.map(video => (
        <IntroOutroPreview key={video} videoUrl={video} onDelete={deleteItem} />
      ))}
    </div>
  );
}
